import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AlertService, DataStore } from "../_services";

import { AuthenticationService } from "../_services";
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Component({ templateUrl: "login.component.html", selector: "login", styleUrls: ["./login.component.css"] })
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  success: string;
  ccode: 91;

  constructor(
    private dataStore: DataStore,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private dbService: NgxIndexedDBService
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(["/"]);
    }
  }
  getNumber(event) {
    this.ccode = 91;
  }
  onCountryChange(event) {
    this.ccode = event.dialCode;
  }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
      provider: ["Approver"],
      AppVersion: 10
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

    // show success message on registration
    if (this.route.snapshot.queryParams["registered"]) {
      this.success = "Registration successful";
    }
  }

  // convenience getter for easy access to form fields
  get formValidation() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.error = null;
    this.success = null;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.dbService.clear('Things').then(
      () => {
        // console.log("THINGS")
        this.dbService.clear('thingUiObject').then(
          () => {
            // console.log("THING UI OBJECT")
            this.dbService.clear('locationList').then(
              () => {
                this.authenticationService
                  .login(
                    this.ccode + this.formValidation.username.value,
                    this.formValidation.password.value,
                    this.formValidation.provider,
                    this.formValidation.AppVersion
                  )
                  .pipe(first())
                  .subscribe(
                    data => {
                      this.loading = false;
                      this.router.navigate(["/dashboard/things"]);
                    },
                    error => {
                      if (error.statusText == "Unknown Error") {
                        this.alertService.error("Please check your connectivity");
                      } else if (error.status == 400) {
                        this.alertService.error("Please check the entered credentials");
                      }

                      this.loading = false;
                    }
                  );

              },
              error => {
                console.log(error);
              }
            );

          },
          error => {
            console.log(error);
          }
        );
      },
      error => {
        console.log(error);
      }
    );
  }
}
